<ion-modal [class.fullscreen]="fullscreen">
			<ng-template>
				<ion-header>
					<ion-toolbar>
						<ion-buttons slot="start">
							<ion-button
								(click)="close()"
								isCanvasBlank
								[signaturePad]="signaturePad"
								[disabled]="disableButtons"
								expand="block"
								color="danger"
								size="large"
								fill="solid"
							>
								<span class="mx-3">Cancel</span>
							</ion-button>
						</ion-buttons>
						<ion-title class="text-center">Signature</ion-title>
						<ion-buttons slot="end">
							<ion-button
								(click)="save()"
								isCanvasBlank
								[signaturePad]="signaturePad"
								[disabled]="disableButtons"
								expand="block"
								color="success"
								size="large"
								fill="solid"
								data-cy="save-sig-button"
							>
								<span class="mx-3">Save</span>
							</ion-button>
						</ion-buttons>
					</ion-toolbar>
				</ion-header>
				<ion-content #content class="ion-padding">
					<div class="relative signature-pad">
						<div
							*ngIf="!isDesktop"
							class="absolute px-3 text-2xl font-bold text-white transform rotate-90 -translate-x-1/2 -translate-y-1/2 bg-black top-1/2 left-2"
						>
							Your {{ initials ? 'Initials' : 'Signature' }} Here
						</div>

						<div
							*ngIf="isDesktop"
							class="absolute px-3 text-2xl font-bold text-white transform -translate-x-1/2 -translate-y-1/2 bg-black bottom-2 left-1/2"
						>
							Your {{ initials ? 'Initials' : 'Signature' }} Here
						</div>

						<div class="canvas-container">
							<div
								*ngIf="!isDesktop"
								style=" height: 90%; width: 20%; position: absolute; top: 5%; border-right: 1px solid black; border-right-color: currentColor; pointer-events: none"
							>
								<div style="font-size: 50px; transform: rotate(90deg); position: absolute; top: -10px; right: -50px;">x</div>
							</div>
							<canvas data-cy="sig-canvas" class="signature-pad-canvas" #canvas style="touch-action: none;"></canvas>
						</div>
					</div>
				</ion-content>
			</ng-template>
		</ion-modal>
		<ion-modal #consentModal [class.fullscreen]="fullscreen">
			<form [formGroup]="form" (ngSubmit)="onProcessConsentForm()">
				<ng-template>
					<ng-container *ngIf="showCancellationPolicy">
						<ion-header>
							<ion-toolbar>
								<ion-title>Cancellation Policy</ion-title>
								<ion-buttons slot="end">
									<ion-button data-cy="i-agree-button" (click)="presentSignature()" expand="block" fill="solid" color="primary">
										<span class="px-3">I Agree</span>
									</ion-button>
								</ion-buttons>
							</ion-toolbar>
						</ion-header>
						<ion-content #content class="ion-padding">
							<div class="mt-5" *ngIf="companyRepo.active$ | async as company">
								<div [innerHtml]="replaceSignaturePlaceholders(company.cancellation_policy)"></div>
							</div>
						</ion-content>
					</ng-container>
					<ng-container *ngIf="!showCancellationPolicy">
						<ion-header>
							<ion-toolbar>
								<ion-title class="text-center">Signature Consent</ion-title>
							</ion-toolbar>
						</ion-header>
						<ion-content #content class="ion-padding">
							<div class="mt-5">
								<p class="text-sm font-bold">
									{{ customMessage }}
								</p>
							</div>
							<div class="mt-5">
								<p class="text-xs">
									By submitting this signature, you hereby consent, acknowledge and agree that your electronic signature is intended
									to authenticate and to execute this agreement as well as any other notices, acknowledgements or other documents
									that you sign in connection with the... transactions between us, and that each electronic signature will have the
									same force and effect as an original signature on paper . You have the right not to check the box and request that
									you manually sign a paper copy instead. By submitting this signature, you are waiving that right. You may,
									following your execution of the document(s) upon written request to us, obtain a single paper copy of the
									electronic record(s). No fee will be charged for any such copies, and no special hardware or software is required
									to view the electronic or digital copies. Your agreement and consent to use an electronic signature with us for
									any documents will continue until such time as you notify us in writing that you no longer wish to use an
									electronic signature. There is no penalty for withdrawing your consent. You should always make sure that we have a
									current email address in order to contact you regarding any changes, if necessary. Without limiting the foregoing,
									your electronic signature evidences your agreement to the terms of the rental agreement, waiver, acknowledgements
									and completion of logged safety briefing steps. If you need to update your email address or would like a paper
									copy of the electronic records, please contact
								</p>
								<div class="mt-2 text-sm font-semibold" *ngIf="companyRepo.active$ | async as company">
									{{ company.company_name }} |
									{{ company.email }}
								</div>
								<ion-item class="ion-margin-top">
									<ion-label color="primary" padding-top="30px">
										<span class="text-lg">I can read and understand English</span>
									</ion-label>
									<ion-checkbox formControlName="consentEnglish"></ion-checkbox>
								</ion-item>
								<ion-item>
									<ion-label color="primary"><span class="text-lg ion-text-wrap">Consent to use electronic signature</span></ion-label>
									<ion-checkbox formControlName="consentSignautare"></ion-checkbox>
								</ion-item>
								<div class="mt-4 space-y-4">
									<div>
										<ion-button (click)="onProcessConsentForm()" expand="block" color="success" fill="solid" [disabled]="(form.statusChanges | async) !== 'VALID'">I Agree </ion-button>
									</div>
									<ion-button (click)="consentModal.dismiss()" expand="block" color="danger" fill="solid">
										<span class="mx-3">Cancel</span>
									</ion-button>
								</div>
							</div>
						</ion-content>
					</ng-container>
				</ng-template>
			</form>
		</ion-modal>